import React from 'react';
import { ChevronRight, Home, ShieldCheck } from 'lucide-react';
import LogSecurityList from '../../components/LogSecurity/LogSecurityList';

const css = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800;900&display=swap');
.logs-page, .logs-page * { box-sizing: border-box; }
.logs-page { font-family: 'DM Sans', sans-serif; }
@keyframes logsFadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
.logs-page__header { animation: logsFadeUp .45s cubic-bezier(.16,1,.3,1) both; }
.logs-page__content { animation: logsFadeUp .45s .07s cubic-bezier(.16,1,.3,1) both; }
`;

const LogsSecurityPage: React.FC = () => (
    <>
        <style>{css}</style>
        <main className="logs-page" style={{ background: '#fff', minHeight: '100vh', padding: 'clamp(24px,3vw,36px) clamp(16px,4vw,40px)' }}>
            <div style={{ maxWidth: 1480, margin: '0 auto' }}>
                <header className="logs-page__header" style={{ marginBottom: 28 }}>
                    <nav aria-label="Ruta de navegación" style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '.72rem', fontWeight: 600, color: '#94a3b8', marginBottom: 12 }}>
                        <a href="/dashboard" style={{ color: '#94a3b8', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                            <Home size={11} aria-hidden="true" /> Dashboard
                        </a>
                        <ChevronRight size={10} color="#e2e8f0" aria-hidden="true" />
                        <span style={{ color: '#007FC8', fontWeight: 700 }}>Seguridad</span>
                    </nav>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <div aria-hidden="true" style={{ width: 46, height: 46, flex: '0 0 auto', borderRadius: 14, background: 'rgba(0,127,200,.08)', display: 'grid', placeItems: 'center' }}>
                            <ShieldCheck size={22} color="#007FC8" />
                        </div>
                        <div>
                            <h1 style={{ margin: 0, color: '#0f172a', fontSize: 'clamp(1.5rem,3vw,2rem)', fontWeight: 900, letterSpacing: '-.025em', lineHeight: 1.1 }}>Historial de seguridad</h1>
                            <p style={{ margin: '7px 0 0', color: '#64748b', fontSize: '.85rem', fontWeight: 500 }}>Revisa accesos, intentos y eventos sensibles registrados.</p>
                            <div data-testid="brand-line" aria-hidden="true" style={{ display: 'flex', gap: 5, marginTop: 10 }}>
                                {['#FF2052', '#007FC8', '#EC8400', '#00DBB9'].map((color, index) => <span key={color} style={{ display: 'block', height: 3, width: index === 0 ? 24 : 8, borderRadius: 3, background: color }} />)}
                            </div>
                        </div>
                    </div>
                </header>
                <section className="logs-page__content" aria-label="Registros de seguridad"><LogSecurityList /></section>
            </div>
        </main>
    </>
);

export default LogsSecurityPage;

